export const isNavigationPathActive = (pathname, path) => pathname === path || pathname.startsWith(`${path}/`);

export function prepareNavigation(items, search = '') {
    const query = search.trim().toLowerCase();
    // Keep the dashboard and statements at the top of the workspace navigation.
    const navigation = items.flatMap((item) => item.id === 'overview' ? item.children : [item]);
    return navigation.flatMap((item) => {
        if (!query) return [item];
        if (item.type === 'link') return item.label.toLowerCase().includes(query) ? [item] : [];
        const children = item.label.toLowerCase().includes(query) ? item.children
            : item.children.filter((child) => child.label.toLowerCase().includes(query));
        return children.length ? [{ ...item, children }] : [];
    });
}

export function activeNavigationPath(items, pathname) {
    return items.flatMap((item) => item.type === 'group' ? item.children : [item])
        .filter((item) => isNavigationPathActive(pathname, item.to))
        .sort((left, right) => right.to.length - left.to.length)[0]?.to;
}
